import { render, staticRenderFns } from "./SearchTips.vue?vue&type=template&id=e62cf6ca&"
import script from "./SearchTips.vue?vue&type=script&lang=js&"
export * from "./SearchTips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports